<script setup lang="ts">
useSeoMeta({
  title: 'Privacy Policy — QikSolve',
  description: 'QikSolve privacy policy.',
});
</script>

<template>
  <section class="max-w-3xl mx-auto px-4 py-16 prose">
    <h1>Privacy Policy</h1>
    <p class="text-sm text-gray-500">
      Last updated: 21 September 2023
    </p>

    <h2>Welcome to QikSolve</h2>
    <p>
      Privacy and online safety are important to QikSolve. We offer consulting services, software configuration
      and sales, training (both offline and online) and downloadable templates to organisations that must meet
      regulations enforced by the Australian Therapeutic Goods Administration and equivalent government bodies
      in other countries that are members of the Pharmaceutical Inspection Co-operation Scheme. We collect data
      about organisations, their employees, suppliers and customers ("Data") when they use our services and
      visit our websites (collectively, "Services"). This privacy policy describes how we collect, use and
      disclose that data.
    </p>
    <p>
      We respect and are committed to protecting your privacy. QikSolve is bound by and intends to comply with
      the Australian National Privacy Principles (NPPs) contained in the Privacy Act 1988 (Cth) when dealing
      with personal information. QikSolve also seeks to comply with the USA's CAN-SPAM Act and the European
      Union's General Data Protection Regulation (GDPR).
    </p>

    <h2>Who is collecting your data?</h2>
    <p>
      QikSolve is an Australian private company, headquartered in Melbourne, Australia. Our Australian Business
      Number is 55 600 26345.
    </p>

    <h2>Contact Us</h2>
    <p>
      If you have any questions about this Privacy Policy, please contact us at
      <a href="mailto:info@qiksolve.com">info@qiksolve.com</a> or via our
      <NuxtLink to="/contact">
        contact page
      </NuxtLink>.
    </p>

    <p class="text-sm text-gray-500">
      This page summarises the full privacy policy migrated from www.qiksolve.com. The complete policy text is
      retained in the original WordPress export for reference.
    </p>
  </section>
</template>
